export default __webpack_public_path__ + "static/media/SYD-logo.9ad96832.png";